import { type FC } from "react";

import { type IAgGridCellProps } from "../cell-base-interfaces.js";
import { getItemsByPattern } from "../column-props-factory.js";
import { createCellLink } from "./core/LinkListCell.js";
import ListCellContent, { type ListCellItem } from "./core/ListCellContent.js";
import { TableCell } from "./core/TableCell.js";
import { type Transcript } from "@/graphql.ts";
import { ENTITY_TYPE } from "@/settings/settings.js";

// with named group
//export const TRANSCRIPTS_ACCESSION_PATTERN = "(?<groupField>(.*\.)?transcripts)\.accession";
export const TRANSCRIPTS_SEQUENCEID_PATTERN = "((.*.)?transcripts).sequenceId";

const TranscriptsCell: FC<IAgGridCellProps> = (props) => {
  if (!props.value || !props.data) {
    return null;
  }

  const { data, colDef } = props;

  const transcripts: Transcript[] = getItemsByPattern(colDef.field, TRANSCRIPTS_SEQUENCEID_PATTERN, data);

  const items: ListCellItem[] = transcripts.map((transcript: Transcript) => ({
    value: createCellLink(transcript.sequenceId, `/${ENTITY_TYPE.TRANSCRIPT}/${transcript.id}`),
    tooltip: transcript.sequenceId,
  }));

  return (
    <TableCell>
      <ListCellContent items={items} colDef={props.colDef} context={props.context} />
    </TableCell>
  );
};

export default TranscriptsCell;
